window.Auth = {
	hideModalAuth: function () {
		$modal = $("#authUser");
		$modal.modal('hide');
	},
	showModalEmail: function () {
		$modal = $("#modal-submit-email");
		$modal.modal('show');
	},
	hideMsg: function($form) {
		$form.find('.msg').hide();
	},
	showError: function ($form, msg) {
		$form.find('.msg.error').html(msg).show();
	},
	showSuccess: function ($form, msg) {
		$form.find('.msg.success').html(msg).show();
	},

	checkAuthAfterLogin: function () {
		$.get('/login/social/check', function (data) {
			if (data.error) {
				if (data.type == 'empty_email') {
					Auth.hideModalAuth();
					Auth.showModalEmail();
				}
			} else {
				location.href = data.redirect_to;
			}
		});
	},
};

window.Auth.Social = {
	socialAuthTm: null,
	socialAuthWindow: null,

	login: function (link) {
		this.socialAuthWindow = popupwindow(link, 'Авторизация', 600, 600);

		clearInterval(Auth.Social.socialAuthTm);

		this.socialAuthTm = setInterval(function () {
			if (Auth.Social.socialAuthWindow.closed) {
				Auth.Social.socialAuthWindow = null;
				Auth.checkAuthAfterLogin();
				clearInterval(Auth.Social.socialAuthTm);
			}
		}, 100);
	},
};

$(document).ready(function () {
	$('[data-login="social"]').click(function () {
		Auth.Social.login($(this).attr('href'));
		return false;
	});

	$("#submit-email-form").submit(function () {
		var route = $(this).attr('action');
		var params = $(this).serializeArray();
		var $form = $(this);

		Auth.hideMsg($form);

		$.post(route, params, function (data) {
			if (data.error) {
				Auth.showError($form, data.msg);
				$form.find('[type=submit]').removeAttr('disabled');
			} else {
				location.href = data.redirect_to;
			}
		});

		return false;
	});
});